import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import ViewDashboard from "../views/ViewDashboard";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";
import { ArrowLeft } from "lucide-react";

const ContainerComponente = styled.div`
  width: 100%;
  min-height: 100vh; /* Garante que ocupa 100% da altura da viewport */
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f4f7;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
`;
const BackButton = styled.button`
  position: absolute;
  top: 110px; /* distância abaixo do AppBar */
  left: 40px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 50%;
  padding: 0.6rem;
  cursor: pointer;
  color: #fff;
  transition: background 0.3s ease, transform 0.2s ease;
  z-index: 20;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.05);
  }

  svg {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 768px) {
    top: 90px;
    left: 20px;
    padding: 0.5rem;
    svg {
      width: 20px;
      height: 20px;
    }
  }
`; 


const Dashboard: React.FC = () => {

const { isLoading, isValid } = usePermissao("ADM");

       const handleVoltar = () => {
    // 🔙 Volta para a página anterior
    window.history.back();
  };
       
         if (isLoading) return <p>Verificando permissão...</p>;
         if (!isValid) return null;
  return (
      <ContainerComponente>
        <BackButton onClick={handleVoltar} title="Voltar">
                <ArrowLeft />
              </BackButton>
    <ContatoZap />
    <ViewAppBar />
    <ViewDashboard />
    <ViewFooter />
  </ContainerComponente>

  );

};

export default Dashboard;
